/**
 * @generated SignedSource<<6e097700b6fb770ccc788c2ea7646268>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StatusColumnHeader_column$data = {
  readonly collapsed: boolean;
  readonly id: string;
  readonly name: string;
  readonly statuses: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"BoardHeaderDropdown_status">;
  } | null | undefined>;
  readonly " $fragmentType": "StatusColumnHeader_column";
};
export type StatusColumnHeader_column$key = {
  readonly " $data"?: StatusColumnHeader_column$data;
  readonly " $fragmentSpreads": FragmentRefs<"StatusColumnHeader_column">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "StatusColumnHeader_column",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "collapsed"
      },
      "action": "THROW",
      "path": "collapsed"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "statuses",
        "plural": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "BoardHeaderDropdown_status"
          }
        ]
      },
      "action": "THROW",
      "path": "statuses"
    }
  ],
  "type": "JiraBoardViewStatusColumn"
};

(node as any).hash = "dd6c1de8753cc7c89deed94b88bf820c";

export default node;
